import { Component, Input } from '@angular/core';
import { TripProtectionBanner } from './data-models/trip-protection-banner.interface';

@Component({
  selector: 'idp-trip-protection-banner',
  templateUrl: './trip-protection-banner.component.html',
  styleUrls: ['./trip-protection-banner.component.scss']
})
export class TripProtectionBannerComponent {
  @Input() config: TripProtectionBanner = {} as TripProtectionBanner;
}
